import PropTypes from 'prop-types';
import styles from './FJVoiceCloningSuccess.module.less';
import FJLocalStore from '../../../store/FJLocalStore.js';
import FJAudioPlay from '../../../common/components/audio/FJAudioPlay/FJAudioPlay.jsx';
import FJButton from '../../../common/components/FJButton/FJButton.jsx';
import FJSuccessIcon from '../../../assets/svg/ttv/success.svg?react';

const FJVoiceCloningSuccess = props => {
    const { goHistory, audioUrl } = props;
    return (
        <>
            <div className={styles.header_bg} />
            <div className={styles.box}>
                <FJSuccessIcon />
                <div className={styles.title}>{FJLocalStore._('your-voice-has-been-cloned-successfully')}</div>
                <div className={styles.content}>
                    <div className={styles.sub_title}>{FJLocalStore._('preview-voice')}</div>
                    <FJAudioPlay audioUrl={audioUrl} isOnlyPreview />
                </div>
                <div className={styles.btn_box}>
                    <FJButton text='done' type='gradient' className={styles.done_btn} onClick={goHistory} />
                </div>
            </div>
        </>
    );
};

FJVoiceCloningSuccess.propTypes = {
    goHistory: PropTypes.func,
    audioUrl: PropTypes.string,
};
export default FJVoiceCloningSuccess;
